export default __webpack_public_path__ + "static/media/logo_usu.398c2ac6.svg";